import React from 'react';
import { Formik } from 'formik';
import validation from './validationSchema';
import PhoneField from '../../components/form/PhoneField';
import Spinner from '../Spinner';

const specificKSAPattern = /(057|57)[0-9]{3}[0-9]{4}$/;

const Basic = (props) => {
  const onPhoneChange = (isValid, phone, setFieldValue, other) => {
    setFieldValue('isPhoneValid', isValid);
    setFieldValue('phone', phone);
  };

  const renderLogin = (
    errors,
    setFieldValue,
    isSubmitting,
    touched,
    values
  ) => {
    return (
      <>
        <div className="input-with-icon">
          <PhoneField
            onChange={(isValid, phone, other) =>
              onPhoneChange(isValid, phone, setFieldValue, other)
            }
            className="custom-input"
            disabled={props.disabled}
            onSelectFlag={(flag, e) =>
              setFieldValue('country_code', e.dialCode)
            }
          />
        </div>
        <div style={{ color: 'red' }}>
          {errors.phone && touched.phone && errors.phone}
        </div>
        <div style={{ height: 10 }} />

        <button type="submit" className="login-btn" disabled={isSubmitting}>
          {(props.onProgress === 'SEND_CODE' || props.isGeneratingHash) ? <Spinner /> : 'ارسال الكود'}
        </button>
      </>
    );
  };

  const INITIAL_VALUES = {
    phone: '',
    isPhoneValid: '',
    country_code: '966',
  };
  return (
    <div>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validation}
        validate={(values) => {
          const errors = {};
          if (
            values.country_code === '966' &&
            (values.phone.startsWith('057') || values.phone.startsWith('57'))
          ) {
            if (!specificKSAPattern.test(values.phone.trim())) {
              errors.phone = 'الرقم غير صالح';
            } else {
              values.isPhoneValid = true;
            }
          }
          if (
            !values.isPhoneValid ||
            checkCountryCodeDuplication(values.country_code, values.phone)
          ) {
            errors.phone = 'الرقم غير صالح';
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          props.onSubmit(values);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="login-form">
            {renderLogin(errors, setFieldValue, isSubmitting, touched, values)}
          </form>
        )}
      </Formik>
    </div>
  );
};

function checkCountryCodeDuplication(countryCode, phone) {
  const checkIfPhoneStartsWithCountryCode =
    phone.startsWith(countryCode) || phone.startsWith('00' + countryCode);

  return checkIfPhoneStartsWithCountryCode;
}

export default Basic;
